"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addScalarDependencies = void 0;
var _dependenciesTypedGenerated = require("./dependenciesTyped.generated.js");
var _factoriesAny = require("../../factoriesAny.js");
/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */

var addScalarDependencies = exports.addScalarDependencies = {
  typedDependencies: _dependenciesTypedGenerated.typedDependencies,
  createAddScalar: _factoriesAny.createAddScalar
};